module.exports = __webpack_public_path__ + "static/img/img_program_a.5031c263.png";